import { render, staticRenderFns } from "./list-side.vue?vue&type=template&id=171ab2dc&scoped=true"
import script from "./list-side.vue?vue&type=script&lang=js"
export * from "./list-side.vue?vue&type=script&lang=js"
import style0 from "./list-side.vue?vue&type=style&index=0&id=171ab2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ab2dc",
  null
  
)

export default component.exports